/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-get, ember/require-tagless-components, no-restricted-properties, warp-drive/no-legacy-request-patterns */
// Extends From
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
// Ember Imports
import { service } from '@ember/service';
// Internal Imports
import Day from 'linced-app/enums/medical/day';
import { action } from '@ember/object';
import { rollbackRecord } from '@linc-technologies/linced-common/utils/record-rollback';

export default class ScheduleEntry extends Component {
  @service
  session;

  @service
  store;

  @service
  toaster;

  Day = Day;
  @tracked
  addAnotherDialogOpen = false;
  @tracked
  dialogOpen = false;
  edit = false;
  medication = null;
  @tracked
  schedule = null;

  @tracked
  saveInProgress;

  @action
  openDialog() {
    if (this.edit) {
      this.dialogOpen = true;
    } else {
      this.schedule = this.store.createRecord('medical/schedule', {
        medication: this.medication,
        schoolId: this.get('session.school'),
      });

      this.dialogOpen = true;
    }
  }

  @action
  closeDialog() {
    if (!this.schedule.get('id')) {
      this.schedule.deleteRecord();
      this.schedule = null;
    } else {
      // Restore any altered attributes and relationships.
      rollbackRecord(this.schedule);
    }
    this.dialogOpen = false;
  }

  @action
  closeAddAnotherDialog() {
    this.addAnotherDialogOpen = false;
  }

  @action
  save() {
    this.saveInProgress = true;
    return this.schedule
      .save()
      .then(() => {
        this.toaster.success('Schedule saved successfully!');
        this.dialogOpen = false;
        if (!this.edit) {
          this.addAnotherDialogOpen = true;
        }
      })
      .catch(() => {
        // Stay open to retry; closeDialog discards the unsaved schedule.
        this.toaster.error('Schedule save failed!');
      })
      .finally(() => {
        this.saveInProgress = false;
      });
  }

  @action
  addAnother() {
    this.closeAddAnotherDialog();
    this.openDialog();
  }

  @action
  toggleDay(dayNumber) {
    if (this.schedule.days.includes(dayNumber)) {
      this.schedule.days.removeObject(dayNumber);
    } else {
      this.schedule.days.addObject(dayNumber);
    }
  }
}
